import { useDropdownMenuItems } from './useDropdownMenuItems';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useProfile } from '@/hooks';

export function ProfileItemDropdown({
  className,
}: React.ComponentProps<typeof DropdownMenuTrigger>) {
  const { manager } = useProfile();
  const initials =
    manager.vorname[0].toUpperCase() + manager.nachname[0].toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={className}>
        <Avatar className="size-8">
          <AvatarFallback data-testid="navigation-avatar">
            {initials}
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end">
        <DropdownMenuLabel>
          {manager.vorname + ' ' + manager.nachname}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {...useDropdownMenuItems()}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
